import type { ProjectApiContract } from '../../../core/api';
import type { ProjectUiModel } from '../../../core/types';
import { getInitials } from '../../../shared/utils';
import { environment } from '../../../../environments/environment';

export function mapProjectContractToUiModel(contract: ProjectApiContract): ProjectUiModel {
  const name = contract.name?.trim() || contract.id || 'Project';
  return {
    id: contract.id,
    name,
    description: contract.description,
    coverImageUrl: normalizeCoverImageUrl(contract.coverImageUrl),
    iconKey: contract.iconKey || 'folder',
    colorHex: contract.colorHex ?? null,
    initials: getInitials(name, 'PR'),
  };
}

/** Normaliza URL de capa do projeto (absoluta, API base, assets). Reutilizável fora do adapter. */
export function normalizeCoverImageUrl(value: string | null): string | null {
  if (!value) return null;

  const raw = value.trim();
  if (!raw) return null;

  if (/^https?:\/\//i.test(raw) || raw.startsWith('data:')) {
    return raw;
  }

  const normalized = raw.replace(/\\/g, '/').replace(/\/{2,}/g, '/');

  if (normalized.startsWith('/assets/') || normalized.startsWith('assets/')) {
    return normalized.startsWith('/') ? normalized : `/${normalized}`;
  }

  const baseUrl = environment.apiUrl.replace(/\/$/, '');

  if (normalized.startsWith('/')) {
    return `${baseUrl}${normalized}`;
  }

  return `${baseUrl}/${normalized}`;
}
